import gql from 'graphql-tag';

import { EventDetailsFragment, SmallEventDetailsFragment } from './fragments/EventFragment';
import { DepartmentDataFragment } from './fragments/DepartmentFragment';
import {
  AdmissionRoundFragment,
  AdmissionRoundExamRequiredDetailFragment,
} from './fragments/AdmissionRoundFragment';

export const queryDepartmentDetails = gql`
  query GetDepartment(
    $depId: Int!
    $showLikes: Boolean = true
    $showEvents: Boolean = false
    $smallEvent: Boolean = false
    $includeRound: Boolean = false
    $roundDetails: Boolean = false
  ) {
    department(id: $depId) {
      id
      ...DepartmentDataFragment
      events @include(if: $showEvents) {
        ...SmallEventDetailsFragment @include(if: $smallEvent)
        ...EventDetailsFragment @skip(if: $smallEvent)
      }
      # roundDetails @include(if: $includeRound) {
      #   ...EventDetailsFragment
      # }
      admissionRounds @include(if: $includeRound) {
        id
        ...AdmissionRoundFragment @include(if: $includeRound)
        ...AdmissionRoundExamRequiredDetailFragment @include(if: $roundDetails)
      }
      likes @include(if: $showLikes)
    }
  }
  ${SmallEventDetailsFragment}
  ${EventDetailsFragment}
  ${DepartmentDataFragment}
  ${AdmissionRoundFragment}
  ${AdmissionRoundExamRequiredDetailFragment}
`;

const SCORE_TEXTS = ['คะแนนต่ำสุด', 'คะแนนเฉลี่ย', 'คะแนนสูงสุด'];
const roundYear = year => (year > 0 ? year % 100 : '');

export const convertScore = (score = {}) => [
  {
    score: score.min,
    scoreLabel: `${SCORE_TEXTS[0]} ${roundYear(score.year)}`,
    type: score.scoreType,
    noDataText: '-',
  },
  {
    score: score.avg,
    scoreLabel: `${SCORE_TEXTS[1]} ${roundYear(score.year)}`,
    type: score.scoreType,
    noDataText: '-',
  },
  {
    score: score.max,
    scoreLabel: `${SCORE_TEXTS[2]} ${roundYear(score.year)}`,
    type: score.scoreType,
    noDataText: '-',
  },
];
